import { MedicalPaOrdersAuthStatus } from "../../../../enums/medicalPaOrdersAuthStatus";
import CustomCheckBox from "../../../customCheckBox/customCheckBox";
import {
  DraftSubmissionFormData,
  ErrorStates,
} from "../hooks/useDraftSubmissionFormDataWithErrorStates";

interface MultiSelectJCodeProps {
  formData: DraftSubmissionFormData;
  setFormData: (
    updater: (prevFormData: DraftSubmissionFormData) => DraftSubmissionFormData,
  ) => void;
  errorStates: ErrorStates;
  jCodeOptions: {
    value: string;
    label: string;
    description: string;
    authStatus: string;
  }[];
  selectedJCodeId: string;
}

const MultiSelectJCode = (props: MultiSelectJCodeProps) => {
  const { formData, setFormData, jCodeOptions } = props;

  return (
    <div className="draft-submission-modal--jcodes-container flex flex-col gap-1">
      <div className="multi-select-box--header text-tiny">
        Select Drugs / JCodes{" "}
        <span className="required-asterisk text-sm text-[#FF0000]">*</span>
      </div>
      <div className="multi-select-box--body">
        {jCodeOptions.map((jCode) => (
          <div key={jCode.value} className="multi-select-box--item">
            <CustomCheckBox
              id={jCode.value.toString()}
              label={jCode.label}
              isDisabled={
                jCode?.authStatus === MedicalPaOrdersAuthStatus.AuthReview
              }
              className="mt-1 text-small"
              isChecked={formData.jCodes.includes(jCode.value.toString())}
              onCheckBoxValueChange={(e) =>
                setFormData((prevFormData: DraftSubmissionFormData) => ({
                  ...prevFormData,
                  jCodes: e.value
                    ? [...prevFormData.jCodes, jCode.value.toString()]
                    : prevFormData.jCodes.filter(
                        (jCodeItem: string) =>
                          jCodeItem !== jCode.value.toString(),
                      ),
                }))
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiSelectJCode;
